import BaseService from './BaseService'

class LocationService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  ids = ids => this.requests.post(`/ids`, { ids })
  getTags = (locationId: string) => this.requests.get(`/${locationId}/tags`)
  search = (companyId, deleted, status?, skip?, limit?, query?) =>
    this.requests.get(
      `/search?deleted=${deleted}&companyId=${companyId}${status ? `&status=${status}` : ''
      }${skip ? `&skip=${skip}` : ''}${limit ? `&limit=${limit}` : ''}${query ? `&query=${query}` : ''
      }`
    )
  searchQuery = (companyId, deleted, query) =>
    this.requests.get(
      `/search?deleted=${deleted}&companyId=${companyId}&query=${query}&limit=50`
    )
  read = (locationId: string) => this.requests.get(`/${locationId}`)
  CustomValues = {
    create: (locationId: string, data: { [key: string]: any }) =>
      this.requests.post(`/${locationId}/customValues/`, data),
    read: (locationId: string, customValueId: string) =>
      this.requests.get(`/${locationId}/customValues/${customValueId}`),
    update: (
      locationId: string,
      customValueId: string,
      data: { [key: string]: any }
    ) =>
      this.requests.put(`/${locationId}/customValues/${customValueId}`, data),
    delete: (locationId: string, customValueId: string) =>
      this.requests.delete(`/${locationId}/customValues/${customValueId}`),
    list: (locationId: string) =>
      this.requests.get(`/${locationId}/customValues/`),
    restoreCustomValue: (customValueId: string,locationId:string) =>
      this.requests.put(`/${locationId}/customValues/${customValueId}/restore`,{}),
  }

  CustomFields = {
    create: (locationId: string, data: { [key: string]: any }) =>
      {
        return this.requests.post(`/${locationId}/customFields/`, data)
      },
    read: (locationId: string, customFieldId: string) =>
      this.requests.get(`/${locationId}/customFields/${customFieldId}`),
    update: (
      locationId: string,
      customFieldId: string,
      data: { [key: string]: any }
    ) =>
      {
        return this.requests.put(`/${locationId}/customFields/${customFieldId}`, data)
      },
    delete: (locationId: string, customFieldId: string) =>
      this.requests.delete(`/${locationId}/customFields/${customFieldId}`),
    search: (locationId: string, parentId='custom', skip=0, limit=10, documentType = 'field', query="", model="contact", includeStandards=true) =>
      this.requests.get(`/${locationId}/customFields/search?parentId=${parentId}&skip=${skip}&limit=${limit}&documentType=${documentType}&model=${model}&query=${query}&includeStandards=${includeStandards}`),
    move: (locationId: string,parentId: string,fieldIds:string[]) => this.requests.put(`/${locationId}/customFields/bulk/parent`, {parentId,fieldIds}),
    updatePosition: (
      locationId: string,
      customFieldId: string,
      data: { [key: string]: any }
    ) =>
      this.requests.put(`/${locationId}/customFields/${customFieldId}/position`, data),
    restoreCustomField: (customFieldId: string,locationId:string) =>
      this.requests.post(`/${locationId}/customFields/${customFieldId}/restore`,{}),
  }
  Tasks = {
    list: (queryData: { [key: string]: any }) =>
      this.requests.get(`/${queryData.locationId}/tasks?isLocation=${queryData.isLocation}${queryData.userId ? `&userId=${queryData.userId}` : ''}${queryData.contactId ? `&contactId=${queryData.contactId}` : ''}`),
    read: (locationId: string, taskId: string) =>
      this.requests.get(`/${locationId}/tasks/${taskId}`),
    delete: (locationId: string, taskId: string) =>
      this.requests.delete(`/${locationId}/tasks/${taskId}`),
    accountTaskUpdate: (locationId: string, taskId: string, queryData: { [key: string]: any }) =>
      this.requests.put(`/${locationId}/tasks/${taskId}`, queryData),
    accountTaskCreate: (locationId: string, queryData: { [key: string]: any }) =>
      this.requests.post(`/${locationId}/tasks`, queryData),
  }
  Notes = {
    list: (locationId: string) =>
      this.requests.get(`/${locationId}/notes`),
    read: (locationId: string, noteId: string) =>
      this.requests.get(`/${locationId}/notes/${noteId}`),
    create: (locationId: string, queryData: { [key: string]: any }) =>
      this.requests.post(`/${locationId}/notes`, queryData),
    update: (locationId: string, noteId: string, queryData: { [key: string]: any }) =>
      this.requests.put(`/${locationId}/notes/${noteId}`, queryData),
    delete: (locationId: string, noteId: string) =>
      this.requests.delete(`/${locationId}/notes/${noteId}`),
  }
  Tags = {
    list: (locationId: string,skip: number,limit: number,search: string) =>
      this.requests.get(`/${locationId}/tags?&skip=${skip}&limit=${limit}&search=${search}`),
    read: (locationId: string,tagId:string) =>
      this.requests.get(`/${locationId}/tags/${tagId}`),
    create: (locationId: string, queryData: { [key: string]: any }) =>
      this.requests.post(`/${locationId}/tags`, queryData).then(value => wait(3000, value)),
    update: (locationId: string, tagId: string, queryData: { [key: string]: any }) =>
      this.requests.put(`/${locationId}/tags/${tagId}`, queryData).then(value => wait(3000, value)),
    delete: (locationId: string, tagId: string) =>
      this.requests.delete(`/${locationId}/tags/${tagId}`).then(value => wait(3000, value)),
    bulkDelete: (locationId: string, tags: []) =>
      this.requests.post(`/${locationId}/tags/bulk/delete`, { tagIds: tags }).then(value => wait(3000, value)),
    restoreTag: (tagId: string,locationId:string) => this.requests.put(`/${locationId}/tags/${tagId}/restore`,{}),
  }
  Lab = {
    addFeedback: (locationId: string, body: { [key: string]: any }) =>
      this.requests.post(`/${locationId}/labs/feedbacks`, body),
    getFeatureFlags: (locationId: string) =>
      this.requests.get(`/${locationId}/labs/featureFlags/`),
    upsertFeatureFlag: (locationId: string, body: { [key: string]: any }) =>
      this.requests.put(`/${locationId}/labs/featureFlags`, body),
  }
  ConversationChannels = {
    list: (locationId: string, type: string) =>
      this.requests.get(`/${locationId}/conversationChannels/${type}`),
    update: (locationId: string, queryData: { [key: string]: any }) =>
      this.requests.put(`/${locationId}/conversationChannels`, queryData),
  }
  OptOutMessage = {
    toggleOptOutLanguageForLocation: (locationIds: string[], companyId: string) =>
      this.requests.put(`/smsOptOut/toggle`, {
        locationIds,
        companyId
      }),

    updateOptOutLanguage: (locationIds: string[], companyId: string, optOutMessage: string) =>
      this.requests.put(`/smsOptOut/message`, {
        locationIds,
        companyId,
        optOutMessage
      }),
  }
  SenderInfo = {
    updateSenderInfo: (locationId: string, companyId: string, senderIdPosition: string, senderInfoMessage: string, senderId: string, toggle: boolean) =>
      this.requests.put(`/${locationId}/smsSenderInfo`, {
        companyId,
        senderIdPosition,
        senderInfoMessage,
        senderId,
        toggle,
      })
  }
}

function wait(ms, value) {
  return new Promise(resolve => setTimeout(resolve, ms, value));
}

const instance = new LocationService(BaseService.servicesConfig.Locations)

export default instance
